// in custom-plotly.js
const Plotly = require('plotly.js/lib/core')
const pie = require('plotly.js/lib/pie')
const bar = require('plotly.js/lib/bar')

Plotly.register([
  pie,
  bar
])

module.exports = Plotly



// WEBPACK FOOTER //
// ./src/utils/custom-plotly.js